import React, { FC, useEffect, useState } from 'react'
import { ItemProps } from '../../types'
import ValidationError from '@/components/Form/elements/ValidationError'


const Checkbox: FC<ItemProps> = (
	{
		formItem,
		validation,
		disabled = false,
		formData,
		onChange,
		onFocus,
		onBlur,
		onKeyDown,
		autoFocus,
	},
) => {

	const [checked, setChecked] = useState(formData[formItem.name] || false)

	const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const isChecked = event.target.checked
		setChecked(isChecked)
		onChange?.(formItem.name, isChecked)
	}

	useEffect(() => {
		if (formData[formItem.name] !== checked) {
			setChecked(formData[formItem.name])
		}
	}, [formData, formItem.name, checked])

	return (
		<>
			<label
				tabIndex={0}
				className={
					`select-none flex items-center ` +
					`${!disabled ? 'cursor-pointer' : 'cursor-default'} group gap-sm flex-row outline-none transition-all ` +
					`${formItem.classNames?.content || ''} `

				}
				onClick={(e) => e.stopPropagation()}
			>
				<input
					type="checkbox"
					name={formItem.name}
					className="form-checkbox hidden"
					checked={checked === true ? true : false}
					onChange={handleCheckboxChange}
					onFocus={onFocus}
					onBlur={onBlur}
					onKeyDown={onKeyDown}
					disabled={disabled}
					autoFocus={autoFocus}
				/>

				<div
					className={
						`w-[18px] h-[18px] flex items-center justify-center rounded-sm border shadow-xs transition-all ` +
						`${checked ?
							disabled
								? 'bg-gray-300 border-gray-400 '
								: 'bg-primary-500 border-primary-700 '
							: 'bg-white border-gray-300 '
						} ` +
						`${!disabled ? 'group-hover:border-primary-500' : ''} ` +
						`${validation ? 'border-red-500 border-2 focus:border-red-600 focus:shadow-red hover:border-red-600' : ''}`
					}
				>
                <span
	                className={`font-icon-solid text-white text-[12px] transition-all ${
		                checked ? 'opacity-100 scale-100' : 'opacity-0 scale-150'
	                }`}
                >
                    
                </span>
				</div>
				<span
					className={`${
						!disabled ? 'text-gray-900' : 'text-gray-400'
					} transition-all text-text-md`}
				>
                {formItem.label}
            </span>
				{formItem.itemOptions?.description && (
					<span className="text-gray-400">{formItem.itemOptions?.description}</span>
				)}
			</label>
			<ValidationError error={validation} formItem={formItem} />
		</>
	)
}

export default Checkbox
